$(document).ready(function() {
    if ($('body').data('router-name') !== 'human-translator-to-translate-skip') {
        return;
    }

    window.ajaxLoadRow.initialize(toTranslateSkipUrl, 5);
});
